export const OTC_PLACEMENT = 'OTC Market';
